
export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Upload',
      description: 'Send us your empty room photos through our secure platform. High-quality images work best.'
    },
    {
      number: '02',
      title: 'Select Style',
      description: 'Choose from modern, traditional, or custom design styles that match your target market.'
    },
    {
      number: '03',
      title: 'Review',
      description: 'We create your staged images within 24 hours. Request revisions if needed at no extra cost.'
    },
    {
      number: '04',
      title: 'Download',
      description: 'Receive high-resolution images ready for MLS listings, websites, and marketing materials.'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-light mb-4">Simple Process</h2>
          <p className="text-lg text-gray-600">Get professionally staged photos in just four easy steps</p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute top-16 left-0 right-0 h-0.5 border-t-2 border-dashed border-gray-300"></div>

          <div className="grid md:grid-cols-4 gap-8 md:gap-4">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 rounded-full bg-[#FF6B6B] text-white flex items-center justify-center text-xl font-bold mb-6 relative z-10">
                    {step.number}
                  </div>
                  <h3 className="text-2xl font-bold mb-3">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{step.description}</p>
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-8 -right-2 text-gray-300">
                    <i className="ri-arrow-right-line text-2xl"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
